import React from 'react';
import { Lists, HeaderSwiper } from '@/components/mixins'
import '../../common/common.scss'
class Platform extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      headerDataLists: [
        { imgPath: require("img/EcosphereDetails/Platformbanner.png"), imgHDPath: `${require("img/EcosphereDetails/Platformbanner.png")} 1x,${require("img/EcosphereDetails/Platformbanner@2x.png")} 2x,${require("img/EcosphereDetails/Platformbanner@3x.png")} 3x`, attachURL: "/" }
      ],
      dataLists: [
        {
          title: '“百工互联”工程咨询在线协作服务平台',
          data: '“百工互联”运用标准化、智能化的协同在线作业方式为客户提供工程量计算、清单编制及计价服务，业务涵盖民建、工建等领域。用户可以在平台便捷发布业务需求，选择不同服务水平和类型的自营团队进行承做，满足用户更广泛、多样化的需求。平台将以专业的直营服务团队，为用户提供快、准、省、优的服务成果。<br/>平台地址:<a class="link" href="https://trade.baigongyi.com/">https://trade.baigongyi.com/</a>',
          imgPath: require("img/EcosphereDetails/Platformicon01.png"), imgHDPath: `${require("img/EcosphereDetails/Platformicon01.png")} 1x,${require("img/EcosphereDetails/Platformicon01@2x.png")} 2x,${require("img/EcosphereDetails/Platformicon01@3x.png")} 3x`
        },
        // {
        //   title: '国内首家电子函证服务平台--函证通',
        //   data: '函证通是在财政部、银监会、人总行的大力支持，在中国注册会计师协会的直接指导下，由一批资深注册会计师和 IT 专业人士共同研发的，基于“互联网 + 审计”的思路，意在实现银行函证电子化的互联网平台。<br/>平台地址:<a class="link" href="https://www.hanzhengtong.com/">https://www.hanzhengtong.com/</a>',
        //   imgPath: require("img/EcosphereDetails/Platformicon02.png"), imgHDPath: `${require("img/EcosphereDetails/Platformicon02.png")} 1x,${require("img/EcosphereDetails/Platformicon02@2x.png")} 2x,${require("img/EcosphereDetails/Platformicon02@3x.png")} 3x`
        // },
        {
          title: '百工驿',
          data: '百工驿平台是由北京百工驿科技有限公司倾力打造的面向工程人的垂直社交移动互联平台，通过内容生产和资源共享，为行业广大从业者创造富有吸引力和价值的线上工作、学习和社交环境，用互联网创新方式助力人才培养、扩大人才供给、加速知识流通。<br/>平台地址:<a class="link" href="https://www.baigongyi.com/">https://www.baigongyi.com/</a>',
          imgPath: require("img/EcosphereDetails/Platformicon03.png"), imgHDPath: `${require("img/EcosphereDetails/Platformicon03.png")} 1x,${require("img/EcosphereDetails/Platformicon03@2x.png")} 2x,${require("img/EcosphereDetails/Platformicon03@3x.png")} 3x`
        },
        // {
        //   title: 'EveryBIM管理平台',
        //   data: 'EBIM应用管理平台是专注于轻量化、简单实用、完全本地化的BIM应用工具，围绕BIM打造现场协同管理平台，可兼容并整合行业内主流建模软件生成的BIM模型，可支持电脑客户端、手机、平板电脑客户端。该平台支持国际IFC标准, 可对模型进行进度跟踪、材料跟踪、运营维护等项目管理功能。已成功应用于国内外上百个不同类型的项目。<br/><a class="link" href="http://www.ezbim.net/products/cooperativePlatform">了解更多...</a>',
        //   imgPath: require("img/EcosphereDetails/Platformicon04.png"), imgHDPath: `${require("img/EcosphereDetails/Platformicon04.png")} 1x,${require("img/EcosphereDetails/Platformicon04@2x.png")} 2x,${require("img/EcosphereDetails/Platformicon04@3x.png")} 3x`
        // },
      ],
    }
  }
  render() {
    return (
      <main>
        <HeaderSwiper headerDataLists={this.state.headerDataLists}></HeaderSwiper>
        <div className="Platform">
          <h5 className='product-title'>服务介绍</h5>
          <Lists dataLists={this.state.dataLists}></Lists>
        </div>
      </main>
    )
  }
}
export default Platform
